import { createReducer, on } from '@ngrx/store';

import { isEqual, isNull } from 'lodash-es';

import * as fromLayoutActions from '../actions/layout.actions';
import * as fromMapActions from '../actions/map.actions';
import * as fromPersistedStateActions from '../actions/persisted-state.actions';

export const mapFeatureKey = 'map';

const defaultCenterLocation: google.maps.LatLngLiteral = { lat: 33.685909, lng: -117.824722 };
const defaultSelectedTypeId: google.maps.MapTypeId = 'hybrid' as google.maps.MapTypeId;
const defaultMapTypeIds: google.maps.MapTypeId[] = [
  'hybrid',
  'roadmap',
  'satellite',
  'terrain'
] as google.maps.MapTypeId[];

const defaultOptions = {
  clickableIcons: false,
  disableDefaultUI: true,
  fullscreenControl: false,
  maxZoom: 22,
  minZoom: 10,
  styles: [
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }]
    }
  ],
  tilt: 0,
  zoomControlOptions: {
    position: 17
  }
};

export interface State {
  availableMapTypeIds: google.maps.MapTypeId[];
  center: google.maps.LatLngLiteral;
  currentMapType: google.maps.MapTypeId;
  markerOptions: google.maps.MarkerOptions;
  options: google.maps.MapOptions;
  userPosition: google.maps.LatLngLiteral | null;
}

export const initialState: State = {
  availableMapTypeIds: defaultMapTypeIds,
  center: defaultCenterLocation,
  currentMapType: defaultSelectedTypeId,
  markerOptions: {
    clickable: false,
    draggable: false
  },
  options: {
    ...defaultOptions,
    mapTypeId: defaultSelectedTypeId,
    zoom: 17
  },
  userPosition: null
};

export const reducer = createReducer(
  initialState,
  on(fromMapActions.mapReset, (state) => ({
    ...state,
    ...initialState
  })),
  on(fromMapActions.updateCurrentMapType, (state, { payload }) => ({
    ...state,
    currentMapType: payload.mapTypeId
  })),
  on(fromMapActions.updateAvailableMapTypeIds, (state, { payload }) => ({
    ...state,
    availableMapTypeIds: payload.availableMapTypeIds
  })),
  on(fromMapActions.updateCenter, (state, { payload }) => ({
    ...state,
    center: payload.location
  })),
  on(fromMapActions.updateUserPosition, (state, { payload }) => {
    const newState = {
      ...state,
      userPosition: payload.location
    };
    if (isEqual(state.center, defaultCenterLocation)) {
      newState.center = payload.location;
    }
    return newState;
  }),
  on(fromMapActions.centerOnUserPosition, (state) => {
    const newState = {
      ...state
    };
    if (!isNull(newState.userPosition)) {
      newState.center = newState.userPosition;
    }
    return newState;
  }),
  on(fromPersistedStateActions.persistedStateReset, fromPersistedStateActions.loadPersistedStateFailure, () => ({
    ...initialState
  })),
  on(fromLayoutActions.updateUseMobileLayout, (state, { payload: { useMobileLayout } }) => ({
    ...state,
    options: {
      ...state.options,
      zoomControl: !useMobileLayout
    }
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[mapFeatureKey],
    options: {
      ...state.options,
      ...payload[mapFeatureKey].options,
      ...defaultOptions
    }
  }))
);
